import {createRouter, createWebHistory} from "vue-router";
import publicRoutes from "./router-public.js";
import privateRoutes from "./router-private.js";

const routes = publicRoutes.concat(privateRoutes);
const router = createRouter({
    history: createWebHistory(process.env.VUE_APP_BASE_URL),
    routes,
    scrollBehavior() {
        return {top: 0};
    }
});

router.beforeEach((to, from, next) => {
    const publicPages = to.name.startsWith("public-");
    const authRequired = !to.name.startsWith("public-");
    const loggedIn = localStorage.getItem("user");
    if (publicPages && loggedIn) {
        // next({ name: "dashboard" });
        next();
    } else if (authRequired && !loggedIn) {
        next({name: "public-login"});
    } else {
        next();
    }

});

export default router;
